





































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from "@vue/composition-api";
import { required, sameAs } from "@vuelidate/validators";
import { useMachine } from "@xstate/vue";
import useVuelidate from "@vuelidate/core";

import { AuthenticationApi } from "@/api";
import isPassword from "@/util/validators/password";
import { mapValidationErrors } from "@/util/Forms";
import ActivateAccountMachine from "./ActivateAccountMachine";

interface PasswordResetForm {
  valid: boolean;
  errors: {};
  fields: {
    activationToken: string;
    password: string;
    passwordRepeat: string;
  };
  validations: {};
}

const Component = defineComponent({
  name: "ActivateAccount",
  setup(props, vm) {
    const password = ref("");
    const passwordRepeat = ref("");

    const { state, send, service } = useMachine(ActivateAccountMachine);
    const api = new AuthenticationApi();

    const form: PasswordResetForm = reactive({
      valid: false,

      fields: {
        activationToken: "",
        password,
        passwordRepeat,
      },

      errors: {},

      validations: useVuelidate(
        {
          password: {
            required,
            password: isPassword,
            $autoDirty: true,
          },
          passwordRepeat: {
            required,
            sameAs: sameAs(password),
            $autoDirty: true,
          },
        },
        { password, passwordRepeat }
      ),
    });

    async function verifyActivationToken(activationToken: string) {
      try {
        await api.authenticationIsActivationTokenValid({
          activationToken,
        });
        form.fields.activationToken = activationToken;
        service.send("RESOLVE");
      } catch (err) {
        service.send("REJECT");
      }
    }

    async function activateAccount() {
      try {
        await api.authenticationActivateAccount({
          activationToken: form.fields.activationToken,
          password: form.fields.password,
        });
        service.send("RESOLVE");
      } catch (err) {
        form.errors = err.response.data.errors;
        service.send("REJECT");
      }
    }

    onMounted(() => {
      if (vm.root.$route.params.token) {
        verifyActivationToken(vm.root.$route.params.token);
      } else {
        service.send("REJECT");
      }

      service.subscribe((s) => {
        if (s.matches("loading")) {
          activateAccount();
        }
      });
    });

    return {
      form,
      mapValidationErrors,
      service,
      send,
      state,
    };
  },
});

export default Component;
